// extracted by mini-css-extract-plugin
export default {"folder":"TreeNodeItemWrapper__folder--seGK6ta4RaGlWYNTR59S","leaf":"TreeNodeItemWrapper__leaf--A3noaWrOmRxkqAfdYqON"};